
<script>

import SliderPhoto from '@/components/slider-photo';

export default {name:"one-complex",

                        props: [
                                'item',
                                'path'
                            ],
                        components:{"slider-photo": SliderPhoto},
                        data:function(){

                            return {
                                        
                                                            
                                    }
						
                        },
                        mounted() {
                            
                           

                        },

                        created: function(){

           
                            //console.log(this.maxHeight);

                        }, 

                        computed: {
							
							
                        },
						methods:{

                            getPath(img)
                            {
                                return this.path+"/images/"+img;
                            }
						
						}

					}

</script>

<template>
    
    <div class="villages__item">

        <a :href="item.DETAIL_PAGE_URL">
            <slider-photo :item="item" :max-height="188" class="slider-villages"></slider-photo>
        </a>
      

        <div class="villages__content-wrapper">
        
            <div class="villages__content">
            <a :href="item.DETAIL_PAGE_URL">
                <p class="villages__content-title">
                    <a :href="item.DETAIL_PAGE_URL">
                        {{item.NAME}}
                    </a>
                </p>
                <p class="villages__content-teg" v-if="item.PROPS && item.PROPS.ADDRESS && item.PROPS.ADDRESS[0]">
                    <span>
                        {{ item.PROPS.ADDRESS[0].VALUE }}
                    </span>
                </p>
                <p class="villages__content-teg" v-else-if="item.ADDRESS">
                    <span>
                        {{ item.ADDRESS }}
                    </span>
                </p>
                <p class="villages__content-teg" v-else-if="item.PROPS && item.PROPS.LOCATION && item.PROPS.LOCATION[0]">
                    <span>
                        {{ item.PROPS.LOCATION[0].VALUE }}
                    </span>
                </p>
                <ul class="villages__content-list" v-if="item.PROPS && item.PROPS.ADDRESS_ADV">
                    <li v-for="address in item.PROPS.ADDRESS_ADV">
                        <span  class="villages__content-link">
                            {{ address.VALUE }}
                        </span>
                    </li>

                </ul>
                </a>
            </div>
            <a href="#reviewResident">
                <div class="village-rating">
                    <div class="rating">
                        <img class="rating-img" loading="lazy" :src="getPath('icon-rating.svg')" alt="Icon">
                        <div class="rating-number">4.9</div>
                    </div>
                    <div class="reviews">
                        <img class="reviews-img" loading="lazy" :src="getPath('icon-reviews.svg')" alt="Icon">
                        <div class="reviews-count" v-if="item.PROPS && item.PROPS.COUNT_FEED && item.PROPS.COUNT_FEED[0]">{{ item.PROPS.COUNT_FEED[0].VALUE }} отзывов</div>
                    </div>
                </div>
            </a>
        </div>
        <!-- <div class="slider-villages-teg" v-if="item.MAX_COUNT > 0">
            <p>Свободные участки {{item.FREE_COUNT}}/{{item.MAX_COUNT}}</p>
        </div> -->
        <div class="slider-villages-teg" v-if="item.FREE_COUNT < 1">
            <img loading="lazy" :src="getPath('icon-check-white.svg')" alt="Icon">
            <p>Полностью реализован</p>
        </div>
    </div>
    
</template>
